module.exports = __webpack_public_path__ + "img/couples-087.c9953ac6.jpg";